import { CloudFile } from 'owa-attachment-file-types';
import { getProviderBrandName } from 'owa-fileprovider-store';
import loc, { format } from 'owa-localize';
import { InsertLinkFailureInfoText } from './insertLink.locstring.json';

export function getInsertLinkFailureInfo(file: CloudFile) {
    const providerBrandName: string = getProviderBrandName(file.providerType);
    return format(loc(InsertLinkFailureInfoText), file.name, providerBrandName);
}
